import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type GenericEntryViewMode = 'list' | 'canvas';

export interface GenericEntryViewState {
	viewMode: GenericEntryViewMode;
}

const initialState: GenericEntryViewState = {
	viewMode: 'canvas',
};

export const genericEntryViewSlice = createSlice({
	name: 'genericEntryView',
	initialState,
	reducers: {
		setViewMode(state, action: PayloadAction<GenericEntryViewMode>) {
			state.viewMode = action.payload;
		},
		toggleViewMode(state) {
			state.viewMode = state.viewMode === 'list' ? 'canvas' : 'list';
		},
	},
});

export const { setViewMode, toggleViewMode } = genericEntryViewSlice.actions;

export const selectGenericEntryViewMode = (state: { genericEntryView: GenericEntryViewState }) =>
	state.genericEntryView.viewMode;

export default genericEntryViewSlice.reducer;
